<template>
	<a-card :bordered="false" class="dashboard-bar-line header-solid">
		<template #title>
			<h6>Balance Overview</h6>
			<p>Last 12 months balance history</p>
		</template>
		<template #extra>
			<a-badge color="#1890ff" class="badge-dot-tertiary" text="Balance" />
		</template>

		<a-spin :spinning="loading">
			<chart-line :height="310" :data="chartData" v-if="chartData.labels.length > 0"></chart-line>
			<div v-else class="no-data-message">
				<a-result status="info" title="No data available" sub-title="No financial data found for the current period">
					<template #extra>
						<a-button type="primary" @click="fetchMonthlyData">
							<a-icon type="reload" />
							Retry
						</a-button>
					</template>
				</a-result>
			</div>
		</a-spin>
	</a-card>
</template>

<script>
	import ChartLine from '../Charts/ChartLine';
	import { authFetch, OrganizationManager } from '../../auth';

	export default {
		name: 'CardFinancialChart',
		components: {
			ChartLine,
		},
		data() {
			return {
				loading: false,
				chartData: {
					labels: [],
					datasets: []
				},
				rawData: null,
			}
		},
		mounted() {
			this.fetchMonthlyData();
		},
		methods: {
			getLast12MonthsRange() {
				const now = new Date();
				// End of current month
				const endOfCurrentMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);
				// Start 12 months ago (beginning of that month)
				const start12MonthsAgo = new Date(now.getFullYear(), now.getMonth() - 11, 1, 0, 0, 0);

				return {
					start: this.$moment(start12MonthsAgo).format('YYYY-MM-DDTHH:mm:ss'),
					end: this.$moment(endOfCurrentMonth).format('YYYY-MM-DDTHH:mm:ss')
				};
			},

			async fetchMonthlyData() {
				this.loading = true;
				try {
					const dateRange = this.getLast12MonthsRange();
					const baseUrl = OrganizationManager.buildOrgUrl('/reports/monthly-overview');
					const url = new URL(baseUrl);
					url.searchParams.append('startDate', dateRange.start);
					url.searchParams.append('endDate', dateRange.end);

					const response = await authFetch(url.toString());

					if (response.ok) {
						this.rawData = await response.json();
						this.processChartData();
					} else if (response.status === 401) {
						this.$message.error('Session expired. Please log in again.');
						this.$router.push('/sign-in');
					} else {
						console.error('Failed to fetch monthly data:', response.status);
						this.chartData = { labels: [], datasets: [] };
					}
				} catch (e) {
					console.error('fetchMonthlyData error', e);
					this.chartData = { labels: [], datasets: [] };
				} finally {
					this.loading = false;
				}
			},

			processChartData() {
				if (!this.rawData || !this.rawData.datasets) {
					this.chartData = { labels: [], datasets: [] };
					return;
				}

				// Process the API response to match Chart.js format
				// Since we now only have balance data, we can simplify this
				const datasets = this.rawData.datasets.map((dataset) => {
					return {
						...dataset,
						tension: 0.4,
						borderWidth: 3,
						pointRadius: 4,
						pointHoverRadius: 6,
						borderColor: '#1890ff',
						backgroundColor: 'rgba(24, 144, 255, 0.1)',
						fill: true,
					};
				});

				this.chartData = {
					labels: this.rawData.labels || [],
					datasets
				};
			},

		},
	}
</script>

<style lang="scss" scoped>
.no-data-message {
	padding: 40px 20px;
	text-align: center;
}

.badge-dot-primary {
	.ant-badge-status-dot {
		background-color: #52c41a;
	}
}

.badge-dot-secondary {
	.ant-badge-status-dot {
		background-color: #ff4d4f;
	}
}

.badge-dot-tertiary {
	.ant-badge-status-dot {
		background-color: #1890ff;
	}
}

.text-success {
	color: #52c41a;
}
</style>
